
(function ($, document) {

    $(document).ready(function () {
        $('.js-readmore').each(function (i, n) {
            var $item = $(this);
            var settings = {
                maxHeight: $item.data('readmore-max-height') || 300,
                speed: 300,
                moreLink: $item.data('readmore-link') || '<span class="btn-more">...read more</span>',
                lessLink: ''
            };
            $item.readmore(settings);
        });
    });

})(jQuery, document);